const StartAppNavItem = ({
  pageNumber = 1,
  isCurrentPage = false,
  isPageComplete = false,
  navName = "",
  currentStep = "0/1",
}) => {
  return (
    <div className="row">
      <div className="col-12">
        <div id={`nav${pageNumber}`} className="nav-button">
          {isCurrentPage ? (
            <>
              <span id="current1" className="current-indicator">
                CURRENT
              </span>
              <br />
              <div className="nav-name">
                <strong>{navName}</strong>
              </div>
            </>
          ) : (
            <div className="nav-name">{navName}</div>
          )}
          <>
            {isPageComplete ? (
              <div id={`check${pageNumber}`}>
                <span className="icon-answer-correct icon-sm"></span>
              </div>
            ) : (
              <div id={`summary${pageNumber}`}>
                <span className="nav-summary-text">{currentStep}</span>
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
};
export default StartAppNavItem;
